import React from "react";
// @ts-ignore
import { Link } from 'react-router-dom';
import consts from "shared/consts";
import { getLibraryURL } from "../utils/get-simulation-library-url";
import NewSimulationButton from "./new-simulation-button";

function qs() {
    return require('qs').parse(location.search.slice(1))
}

export default function OneSimulationHeader(props) {
    const to = getLibraryURL();

    return (
        <>
            <div css={`
                display: display;
                flex-direction: row;
                align-items: center;
            `}>
                <div css={`
                    display:inline;
                    float:left;
                `}>
                    <Link css={`
                        color:#799fd4;
                        display:inline;
                        cursor: pointer;
                        text-decoration-line: underline;
                    `}
                        to={to}>← Back to simulations</Link>
                </div>
            </div>
            <div css={`
                    float: right;
                `}>
                {
                    props.isCiReview ?
                        <Link to={consts.SCR_APP_URLS.ciReview + '/' + props.parentReviewId}>Go to parent review</Link>
                        :
                        <NewSimulationButton isLoggedIn={props.isLoggedIn} />
                }
            </div>
            <br css={`clear:both`} />
        </>
    )
}
